<app-icon-list></app-icon-list>

<div
  class="router-outlet-wrapper"
  [i2gPreventWindowUnloading]="preventWindowUnloadingOptions"
>
  <router-outlet></router-outlet>
</div>

<i2g-toast-messages></i2g-toast-messages>
